import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import {
  classNames,
  FontSize,
  Margin,
  TextAlign,
  TextColor,
} from '@snoam/pinata';
import { ResponsiveContext } from '../context/ResponsiveContext';
import { isProduction } from '../fastflowUtils';

interface IStrexAdditionalInformationProps {
  strexWidgetUrl: string;
  phoneNumber;
  verifyStrexPaymentMethod: () => void;
  toggleBlockLoading: (value?: boolean) => void;
}
const styleClass = {
  errorMessage: classNames(
    TextColor.TEXT_NEGATIVE,
    Margin.MY_2,
    FontSize.TEXT_BASE,
    TextAlign.TEXT_CENTER,
  ),
};

const StrexAdditionalInformation: React.FC<
  IStrexAdditionalInformationProps
> = ({
  strexWidgetUrl,
  phoneNumber,
  verifyStrexPaymentMethod,
  toggleBlockLoading,
}) => {
  const [error, setError] = useState<string>('');
  const responsiveContext = useContext(ResponsiveContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onStrexError = (e) => {
    setError('Noe gikk galt, velg en annen betalingsmetode.');
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onStrexRegistrationCompleted = (e) => {
    toggleBlockLoading();
    verifyStrexPaymentMethod();
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onStrexRegistrationFailed = (e) => {
    setError(
      'Kunne ikke registrere bruker i Strex, velg en annen betalingsmetode.',
    );
  };

  const validateStrexWidgetUrl = (url: string): boolean => {
    const re = /^https:\/\/strex-selfregister.*register\.client\.js$/;
    return re.test(url);
  };
  const getBaseUrl = () => {
    if (isProduction()) {
      return 'https://registrer.strex.no/';
    }
    return 'https://strex-selfregister-at.azurewebsites.net/';
  };

  useEffect(() => {
    if (strexWidgetUrl !== '' && validateStrexWidgetUrl(strexWidgetUrl)) {
      const strexScript = document.createElement('script');
      strexScript.setAttribute('id', 'strexScript');
      strexScript.src = strexWidgetUrl;
      strexScript.async = true;
      strexScript.onload = () => {
        (window as any).strex.hostedView
          .userRegistration({
            accountId: 376,
            baseUrl: getBaseUrl(),
            container: 'strexInformationBox',
            onError: onStrexError,
            onRegistrationCompleted: onStrexRegistrationCompleted,
            onRegistrationFailed: onStrexRegistrationFailed,
            phoneNumber,
            scrolling: 'no',
          })
          .open();
      };
      document.body.appendChild(strexScript);
    }
  }, [strexWidgetUrl]);
  return (
    <div>
      <div
        id={'strexInformationBox'}
        style={{ width: responsiveContext.mobile ? 320 : 490 }}
      />
      {error && <div className={styleClass.errorMessage}>{error}</div>}
    </div>
  );
};

export default StrexAdditionalInformation;
